import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  toolbar: theme.mixins.toolbar,

  title: {
    margin: '2%',
    color: 'rgb(55, 63, 80)',
    [theme.breakpoints.down('465')]: {
      fontSize: '1.6rem'
    }
  },

  subTotal: {
    color: 'rgb(55, 63, 80)',
    [theme.breakpoints.down('465')]: {
      fontSize: '1.6rem'
    }
  },

  span: {
    color: 'rgb(210, 63, 87)'
  },

  Button: {
    margin: '2px 5px',
    [theme.breakpoints.down('465')]: {
      fontSize: '.9rem'
    },
    [theme.breakpoints.down('960')]: {
      margin: '5px 0px',
    }
  },

  checkoutButton: {
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)'
  },

  link: {
    textDecoration: 'none',
  },

  cardDetails: {
    marginTop: '5%',
  },

  container: {
    paddingBottom: '20px',
    minHeight: '500px'
  },

  ButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('960')]: {
      justifyContent: 'start',
      flexDirection: 'column',
    }
  }
}));